/**
 * Scroll Animations Script
 * Animates elements when scrolling into viewport
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    threshold: 0.15, // How much % of element must be visible to trigger animation
    rootMargin: '0px 0px -50px 0px', // Offset for detection (top, right, bottom, left)
    animationDelay: 100 // Delay between animations in ms
  };

  /**
   * Intersection Observer for detecting element visibility
   */
  const observerOptions = {
    threshold: CONFIG.threshold,
    rootMargin: CONFIG.rootMargin
  };

  let observer; // Define observer globally for reinstantiation

  /**
   * Create new observer
   */
  function createObserver() {
    return new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Element is visible
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * CONFIG.animationDelay);
          
          // Stop observing element after it's displayed
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
  }

  observer = createObserver();

  /**
   * Reset all scroll animations
   */
  function resetAnimations() {
    // Find all elements with data-scroll attribute
    const animatedElements = document.querySelectorAll('[data-scroll]');
    
    // Disconnect old observer
    observer.disconnect();
    
    // Remove is-visible class and reset styles
    animatedElements.forEach(element => {
      element.classList.remove('is-visible');
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px)';
    });
    
    // Create new observer
    observer = createObserver();
    
    // Reattach observer to elements
    animatedElements.forEach(element => {
      observer.observe(element);
    });
    
    console.log('🔄 Scroll animations reset');
  }

  /**
   * Initialization
   */
  function init() {
    // Find all elements with data-scroll attribute
    const animatedElements = document.querySelectorAll('[data-scroll]');
    
    // Add class for initial state
    animatedElements.forEach(element => {
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px)';
      observer.observe(element);
    });

    // Reset animations on logo click
    const logoLinks = document.querySelectorAll('.header__logo');
    logoLinks.forEach(logo => {
      logo.addEventListener('click', (e) => {
        // If it's an anchor to #home, reset animations
        const href = logo.getAttribute('href');
        if (href === '#home' || href === '#') {
          e.preventDefault();
          resetAnimations();
          // Scroll to top of page
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });

    // Animation for scroll indicator in hero section
    const scrollIndicator = document.querySelector('.hero__scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.addEventListener('click', () => {
        const firstSection = document.querySelector('#studio');
        if (firstSection) {
          firstSection.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // Parallax effect for hero texture
    const heroTexture = document.querySelector('.hero__texture');
    if (heroTexture) {
      window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        const heroHeight = document.querySelector('.hero').offsetHeight;
        
        if (scrolled < heroHeight) {
          const parallax = scrolled * 0.5;
          heroTexture.style.transform = `translateY(${parallax}px)`;
          heroTexture.style.opacity = 1 - (scrolled / heroHeight) * 0.5;
        }
      }, { passive: true });
    }

    // Animation for gallery dots
    const galleryDots = document.querySelectorAll('.gallery__dots-dot');
    galleryDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        // Remove active class from all dots
        galleryDots.forEach(d => d.classList.remove('gallery__dots-dot--active'));
        // Add active class to clicked dot
        dot.classList.add('gallery__dots-dot--active');
        
        // Here would be logic for changing displayed gallery section
        console.log(`Gallery section ${index + 1} active`);
      });
    });

    // Counter animation for numbers (if needed)
    const animateCounter = (element, target, duration = 2000) => {
      const start = 0;
      const increment = target / (duration / 16); // 60 FPS
      let current = start;

      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          element.textContent = target;
          clearInterval(timer);
        } else {
          element.textContent = Math.floor(current);
        }
      }, 16);
    };

    // Observe counters if they exist
    const counters = document.querySelectorAll('[data-counter]');
    counters.forEach(counter => {
      const counterObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const target = parseInt(counter.getAttribute('data-counter'));
            animateCounter(counter, target);
            counterObserver.unobserve(counter);
          }
        });
      }, { threshold: 0.5 });
      
      counterObserver.observe(counter);
    });
  }

  // Run after DOM loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export functions for possible use from other scripts
  window.ScrollAnimations = {
    init: init,
    reset: resetAnimations
  };

})();
